export default "__VITE_ASSET__Pmkh85sj__"